import { Trans, useTranslation } from "react-i18next";

import { Stack, Typography } from "@mui/material";

import { ExternalUrl } from "../../../../../../constants/externalUrls";
import { ExternalLink } from "../../../../../../external-link/ExternalLink";

export function MaintenanceEntitlementInfo() {
  const { t } = useTranslation();
  const base = "clients.client.debtSettlement.assetInventory.dependants.entitlementInfo";

  return (
    <Stack gap={1} alignItems="flex-start">
      <Typography variant="body2">{t(`${base}.paragraph1`)}</Typography>
      <Typography variant="body2">
        <Trans
          i18nKey={`${base}.paragraph2`}
          components={{
            checkLink: (
              <ExternalLink
                href={ExternalUrl.SpouseMaintenanceCheck}
                variant="body2"
                aria-label={t(`${base}.spouseCheckLinkAria`)}
              />
            ),
          }}
        />
      </Typography>
      <Typography variant="body2">{t(`${base}.paragraph3`)}</Typography>
    </Stack>
  );
}
